class Database {
  constructor() {
    this.dbInstance = null
  }

  async init(customDb, entityName, customConfig = {}) {
    const config = buildDbConfig(customDb.getName(), entityName, customConfig)
    if (!config) throw new Error('Failed to found db adapter')
    this.dbInstance = new customDb()
    await this.dbInstance.init(config)
    return this
  }

  async save(data) {
    return this.dbInstance.save(data).catch(err => {
      console.error(err, data)
      return null
    })
  }

  sort(sortKey, order = 1) {
    const db = this.dbInstance
    return {
      async find(searchQuery = {}) {
        return db.find(searchQuery, sortKey, order == -1).catch(err => {
          console.error(err, searchQuery)
          return null
        })
      },
    }
  }

  async find(searchQuery = {}) {
    return this.dbInstance.find(searchQuery).catch(err => {
      console.error(err, searchQuery)
      return null
    })
  }

  async findOne(id) {
    return this.dbInstance.findOne(id).catch(err => {
      console.error(err, id)
      return null
    })
  }

  async deleteAll() {
    return this.dbInstance.deleteAll().catch(err => {
      console.error(err)
      return null
    })
  }

  async deleteOne(id) {
    return this.dbInstance.deleteOne(id).catch(err => {
      console.error(err, id)
      return null
    })
  }

  async count(searchQuery = {}) {
    return this.dbInstance.count(searchQuery).catch(err => {
      console.error(err, searchQuery)
      return null
    })
  }
}

function buildDbConfig(customDbName, dbName, additionnalConfig) {
  let config = {}
  let customDb = ''
  if (/dexie/i.test(customDbName)) customDb = 'dexieDb'

  switch (customDb) {
    case 'dexieDb':
      config = buildDexieDbConfig(dbName, additionnalConfig)
      break

    default:
      config = null
      break
  }

  return config
}

function buildDexieDbConfig(dbName, config) {
  const dexieConfig = { entityName: dbName }
  if (config.index) dexieConfig.primaryIndex = config.index
  if (config.otherIndexes) dexieConfig.otherIndexes = config.otherIndexes
  return dexieConfig
}

export { Database }
